export const MASCOT_URL =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_bbb24708-d2eb-4e0c-a72d-a72688f7099e/artifacts/ftingkr9_Screenshot%202026-09-30%2011.48.30%20PM.png";

export const INCIDENT_IMAGES = {
  incident_car:
    "https://images.unsplash.com/photo-1687867451910-28941a460f35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxzcG9ydHMlMjBjYXIlMjBjcmFzaHxlbnwwfHx8fDE3OTA5MDY1MDl8MA&ixlib=rb-4.1.0&q=85",
  incident_stream:
    "https://images.unsplash.com/photo-1617507171089-6cb9aa5add36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxsaXZlJTIwc3RyZWFtZXIlMjBzZXR1cHxlbnwwfHx8fDE3OTA5MDY1MDl8MA&ixlib=rb-4.1.0&q=85",
  incident_police:
    "https://images.unsplash.com/photo-1608095476825-d4e0f916372f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxwb2xpY2UlMjBsaWdodHMlMjBzaXJlbnxlbnwwfHx8fDE3OTA5MDY1MDl8MA&ixlib=rb-4.1.0&q=85",
};

export const CATEGORY_META = {
  all: { label: "ALL CHAOS", color: "bg-white text-black" },
  cars: { label: "CARS & CRASHES", color: "bg-[#FF003C] text-white" },
  streaming: { label: "STREAMING", color: "bg-[#FFEA00] text-black" },
  drama: { label: "DRAMA", color: "bg-[#FF00FF] text-black" },
  girlfriends: { label: "RELATIONSHIPS", color: "bg-white text-black" },
  stunts: { label: "STUNTS", color: "bg-[#00FF00] text-black" },
  legal: { label: "LEGAL", color: "bg-[#FF003C] text-white" },
};

export const ACCURACY_META = {
  verified: {
    label: "VERIFIED",
    bg: "#00FF00",
    fg: "#000",
    note: "Widely reported with primary sources.",
  },
  pattern: {
    label: "PATTERN",
    bg: "#FFEA00",
    fg: "#000",
    note: "Directionally true; specific dates/numbers are stylized for comedy.",
  },
};
